import { ArtData, CURRENCY_TYPE } from "../../../types";

export const Price = (props: Parameters<typeof toPriceString>[0]) => {
  return <>{toPriceString(props)}</>;
};

export const toPriceString = ({
  item,
  allowZero,
}: {
  item: Pick<ArtData, "price" | "currency">;
  allowZero?: boolean;
}) => {
  return (item.currency && item.price) ||
    (allowZero && typeof item.price == "number")
    ? (Object.values(CURRENCY_TYPE).find(({ key }) => key === item.currency)
        ?.symbol ?? "Unknown currency") + item.price.toFixed(2)
    : "NO PRICE";
};
